import { useAppSelector } from "@/app/hooks";
import {
  selectUser,
  selectPracticeInfo,
  selectUserFullName,
  selectUserEmail,
  selectUserType,
  selectIsAuthenticated,
  selectUserFirstName,
  selectUserList,
  selectUserProfileImage,
  selectPortalAccountId,
  selectAuthUserId,
  selectProviderId,
  selectProviderCode,
  selectTwoWayTextEnabled,
} from "@/features/Auth/authSelectors";

export const useUser = () => {
  const user = useAppSelector(selectUser);
  const practiceInfo = useAppSelector(selectPracticeInfo);
  const twoWayTextEnabled = useAppSelector(selectTwoWayTextEnabled);
  const firstName = useAppSelector(selectUserFirstName);
  const fullName = useAppSelector(selectUserFullName);
  const userList = useAppSelector(selectUserList);
  const userProfileImage = useAppSelector(selectUserProfileImage);
  const email = useAppSelector(selectUserEmail);
  const userTypeLabel = useAppSelector(selectUserType);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const portalAccountId = useAppSelector(selectPortalAccountId);
  const authUserId = useAppSelector(selectAuthUserId);
  const providerId = useAppSelector(selectProviderId);
  const providerCode = useAppSelector(selectProviderCode);
  return {
    user,
    practiceInfo,
    twoWayTextEnabled,
    firstName,
    fullName,
    userList,
    userProfileImage,
    email,
    userTypeLabel,
    isAuthenticated,
    portalAccountId,
    authUserId,
    providerId,
    providerCode,
  };
};
